<template>
	<div>
		<el-form :model="ruleForm" ref="ruleForm"  label-width="100px" style="text-align: left;">
			<el-row>
				<el-col :span="22">
					<el-form-item label="桥梁状态" prop="status">
						<el-input class="xq-input" v-model="ruleForm.status" placeholder="请输入桥梁状态"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="22">
					<el-form-item label="评判标准" prop="criteria">
						<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" maxlength="150" show-word-limit
							v-model="ruleForm.criteria" placeholder="请输入评判标准"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'jiankangzhuangtai',
		props: [],
		data() {
			return {
				ruleForm: {
					status: '',
					criteria: '',
				},
				
			};
		},
		methods: {
			// 桥梁状态
			async zhuangTaiBC() {
				let data = {
					...this.ruleForm,
					bridgeUuid: global.bridgeUuid,
					createByName: this.$store.state.user.accountName,
					createByUuid: this.$store.state.user.accountUuid,
				}
				const res = await this.$api.sendPost('/biBridge/update', data);
				if (res.errcode == 0) {
					this.$message.success(res.errmsg);
					this.$emit('updateIndex', '8');
				} else {
					this.$message.error(res.errmsg);
				}
			},
			resetForm() {
				this.$refs.ruleForm.resetFields();
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>
